import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestApiConfiguration } from 'src/app/models/RestApiCaller/configuration/rest-api-configuration';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ViewsStateService } from '../state/views-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class RestApiConfigurationsService extends ServiceBase {
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService,
        private viewsStateService: ViewsStateService
    ) {
        super(connectedUserStateService);
    }

    get(apiConfigurationId: number): Observable<RestApiConfiguration> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };

        // Appel de la Web Api
        return this.http.get<RestApiConfiguration>(
            this.baseUrl + `/api/organizations/${this.organizationId}/views/${this.viewsStateService.getSelectedView().id}/rest-api-configurations/${apiConfigurationId}`,
            httpOptions
        );
    }
}
